var a = !1;
export {
  a as i
};
